import Vue from 'vue'
// import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import vuetify from "./plugins/vuetify"
import Vuex from "vuex";
import VueConfetti from "vue-confetti";
import firebase from "firebase/app";

const config = {
  apiKey: "AIzaSyAK0GBCdld1PRCOQq0YaQax1qzKh9R-DXA",
  authDomain: "she-platform.firebaseapp.com",
  databaseURL: "https://she-platform.firebaseio.com",
  projectId: "she-platform",
  storageBucket: "she-platform.appspot.com",
  messagingSenderId: "433186848107"
};

firebase.initializeApp(config);

Vue.use(VueConfetti);

Vue.use(Vuex);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')